export default function Hero() {
  return (
    <section className="relative min-h-screen flex flex-col justify-end pb-24 overflow-hidden">
      {/* Background Image — bright luxury aerial */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/40bec8c62ec81bb7c2d214a51b6b5c3f.jpg"
          alt="PRA Roof Contractors - Expert Roofing Across the Southeast"
          className="w-full h-full object-cover object-top"
        />
        {/* Lighter overlays for brighter feel */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#0d0d0d]/85 via-[#0d0d0d]/45 to-transparent"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-[#0d0d0d]/70 via-transparent to-[#0d0d0d]/10"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10 w-full">
        <div className="max-w-3xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-[#c0392b]/20 border border-[#c0392b]/40 text-[#e74c3c] text-xs font-semibold px-4 py-1.5 rounded-full mb-6 tracking-widest uppercase">
            <i className="ri-shield-check-line"></i>
            Owens Corning Platinum Preferred Contractor
          </div>

          {/* H1 */}
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-black text-white leading-[1.05] tracking-tight mb-6">
            Roofing &amp; Storm<br />
            Restoration Experts<br />
            <span className="text-[#c0392b]">Across the Southeast</span>
          </h1>

          {/* Subheadline */}
          <p className="text-white/80 text-base md:text-lg leading-relaxed max-w-xl mb-4">
            Residential and commercial roofing, storm damage restoration, and exterior services built to protect properties across Texas, Louisiana, North Carolina, and Georgia.
          </p>

          {/* Supporting Copy */}
          <p className="text-white/55 text-sm leading-relaxed max-w-lg mb-10">
            Since 1998, PRA Roof Contractors has helped thousands of property owners recover, rebuild, and protect their homes with expert roofing systems and insurance-driven restoration solutions.
          </p>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="#contact"
              className="inline-flex items-center justify-center gap-2 bg-[#c0392b] hover:bg-[#a93226] text-white font-bold px-8 py-4 rounded-full text-sm transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-calendar-check-line"></i>
              Schedule a Free Roof Inspection
            </a>
            <a
              href="tel:2813779180"
              className="inline-flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 border border-white/30 text-white font-bold px-8 py-4 rounded-full text-sm transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-fill"></i>
              Call Now
            </a>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2 opacity-50">
        <span className="text-white text-xs tracking-widest uppercase">Scroll</span>
        <div className="w-px h-8 bg-white/40 animate-pulse"></div>
      </div>
    </section>
  );
}
